var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/auth/ForgotPassword/steps/ForgotPassSecondStep.tsx";
import React from 'react';
import { Button, Text, VStack } from '@adc/parallax-component-library';
import { Footer, Main, Spinner, TitleActionBar } from 'Components/utility';
import i18n from 'Utilities/i18n';
import log from 'Utilities/log';
const ForgotPassSecondStep = ({
  values,
  handleSubmitForgotPass,
  handleOnDoneClick,
  handleOnBackClick,
  showForgotPasswordConfirmatioMessage,
  loading,
  back
}) => {
  const handleResendEmail = () => {
    handleSubmitForgotPass(values.email).then(showForgotPasswordConfirmatioMessage).catch(err => {
      log.error(err);
    });
  };
  return /*#__PURE__*/React.createElement(Main, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 42,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(TitleActionBar, {
    onBack: () => handleOnBackClick(back),
    titleTestID: "ForgotPass.checkYourEmail",
    actionButtonTestID: "ForgotPass.step2-go-back",
    title: i18n.t('CheckYourEmail.title'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 7
    }
  }), loading && /*#__PURE__*/React.createElement(Spinner, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 49,
      columnNumber: 19
    }
  }), /*#__PURE__*/React.createElement(VStack, {
    flex: 1,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 50,
      columnNumber: 7
    }
  }, /*#__PURE__*/React.createElement(Text, {
    testID: "ForgotPass.instructionsResetSendTo",
    textAlign: "auto",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    color: "$text.100",
    padding: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 51,
      columnNumber: 9
    }
  }, i18n.t('CheckYourEmail.subtitle')), /*#__PURE__*/React.createElement(Text, {
    paddingHorizontal: "$4",
    testID: "ForgotPass.step2-user-email",
    color: "$text.100",
    fontSize: "$bodyBase.strong",
    fontWeight: "$bodyBase.strong",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 61,
      columnNumber: 9
    }
  }, values.email), /*#__PURE__*/React.createElement(VStack, {
    justifyContent: "center",
    alignItems: "center",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 70,
      columnNumber: 9
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: i18n.t('CheckYourEmail.content.checkYourEmail.media.checkYourEmail'),
    alt: "",
    style: {
      objectFit: 'contain',
      height: '70%'
    },
    id: "ForgotPass.step2-check-email-img",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 71,
      columnNumber: 11
    }
  }), /*#__PURE__*/React.createElement(Text, {
    testID: "ForgotPass.notReceiveEmail",
    color: "$text.100",
    fontSize: "$bodyBase.default",
    fontWeight: "$bodyBase.default",
    marginTop: "$4",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 80,
      columnNumber: 11
    }
  }, i18n.t('CheckYourEmail.content.checkYourEmail.primaryText')), /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    testID: "Global.resendEmail",
    onPress: handleResendEmail,
    label: i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label'),
    "aria-label": i18n.t('CheckYourEmail.content.checkYourEmail.links.resendEmail.label'),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 89,
      columnNumber: 11
    }
  }))), /*#__PURE__*/React.createElement(Footer, {
    buttonText: i18n.t('CheckYourEmail.content.checkYourEmail.links.done.label'),
    onButtonSubmit: handleOnDoneClick,
    buttonTestID: "Global.done",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 100,
      columnNumber: 7
    }
  }));
};
export default ForgotPassSecondStep;